function slugify(string) {
  // const a =
  //   "àáäâãåăæąçćčđďèéěėëêęğǵḧìíïîįłḿǹńňñòóöôœøṕŕřßşśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;";

  // const b =
  //   "aaaaaaaaacccddeeeeeeegghiiiiilmnnnnooooooprrsssssttuuuuuuuuuwxyyzzz------";

  // const p = new RegExp(a.split("").join("|"), "g");

  return string.toString().toLowerCase();

  // .replace(/\s+/g, "-") // Replace spaces with -

  // .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters

  // .replace(/&/g, "-and-") // Replace & with 'and'

  // .replace(/[^\w\-]+/g, "") // Remove all non-word characters

  // .replace(/\-\-+/g, "-") // Replace multiple - with single -

  // .replace(/^-+/, "") // Trim - from start of text

  // .replace(/-+$/, ""); // Trim - from end of text
}

function formatDate(D) {
  const day = ("0" + D.getDate()).slice(-2);
  const month = ("0" + (D.getMonth() + 1)).slice(-2);
  const year = D.getFullYear();

  const fullDate = `${year}-${month}-${day}`;

  return fullDate;
}

export { slugify, formatDate };
